import { render, staticRenderFns } from "./Custom.vue?vue&type=template&id=fd7bf9d8&scoped=true"
import script from "./Custom.vue?vue&type=script&lang=ts"
export * from "./Custom.vue?vue&type=script&lang=ts"
import style0 from "./Custom.vue?vue&type=style&index=0&id=fd7bf9d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7bf9d8",
  null
  
)

export default component.exports